export default __webpack_public_path__ + "static/media/inter-regular.2505c0d4.woff2";